<template>
  <div class="finance-page">
    <header class="finance-header">
      <router-link
        to="/user"
        class="back-btn"
      >
        <van-icon name="arrow-left" />
      </router-link>
      <h1>{{ $t('moneybag.todayDetails') }}</h1>
    </header>

    <main class="finance-main">
      <section class="summary-card">
        <div class="summary-item">
          <span>{{ $t('shopCenter.trading') }}</span>
          <strong>{{ utils_moneyMark() }}{{ data.trading }}</strong>
        </div>
        <div class="summary-item">
          <span>{{ $t('moneybag.availmoney') }}</span>
          <strong>{{ utils_moneyMark() }}{{ data.money }}</strong>
        </div>
      </section>

      <section
        v-if="data.list && data.list.length"
        class="record-list"
      >
        <article
          v-for="(v,k) in data.list"
          :key="k"
          class="record-card"
        >
          <div class="record-head">
            <strong>{{ v[lang] }}</strong>
            <b :class="amountClass(v)">{{ formatAmount(v) }}</b>
          </div>
          <div class="record-meta">
            <span>{{ $t('cash.time') }}</span>
            <time>{{ formatBrowserTime(v.time) }}</time>
          </div>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch';
    import { Icon } from 'vant';

    Vue.use(Icon);

    export default {
        name: "Login",
        data() {
            return {
				lang: this.$i18n.locale || "en_us",
                loading: false,
                finished: false,
                data: {},
            };
        },
        created() {
            this.$parent.footer('user');
        },
        mounted() {
            this.start();
        },
        methods: {
            formatAmount(item) {
                const money = item && item.money !== undefined ? String(item.money) : '0.00';
                const sign = String(item && item.type) === '1' ? '+' : '-';

                return sign + money.replace(/^-/, '');
            },
            amountClass(item) {
                return String(item && item.type) === '1' ? 'record-income' : 'record-expense';
            },
            start() {
                Fetch('/user/funds/search', {
                    api: 'funds'
                }).then((r) => {
                    this.data = r.data;
                });
            },
        }
    };
</script>

<style lang="less" scoped>
.finance-page {
    min-height: 100vh;
    background: #f4f5fb;
    color: #061429;
}

.finance-header {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fd;
}

.finance-header h1 {
    margin: 0;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
}

.back-btn {
    position: absolute;
    left: 8px;
    top: 10px;
    width: 28px;
    height: 28px;
    color: #071426;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
}

.finance-main {
    padding: 16px 16px 88px;
}

.summary-card,
.record-card {
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.summary-card {
    min-height: 96px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: center;
    padding: 18px 20px;
    box-sizing: border-box;
}

.summary-item {
    min-width: 0;
}

.summary-item + .summary-item {
    padding-left: 18px;
    border-left: 1px solid #edf0f6;
}

.summary-item span {
    display: block;
    overflow: hidden;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.summary-item strong {
    display: block;
    margin-top: 6px;
    overflow: hidden;
    color: #050b18;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-list {
    margin-top: 18px;
}

.record-card {
    padding: 16px 18px;
}

.record-card + .record-card {
    margin-top: 12px;
}

.record-head,
.record-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
}

.record-head strong {
    min-width: 0;
    overflow: hidden;
    color: #050b18;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-head b {
    flex: 0 0 auto;
    max-width: 42%;
    margin-left: 12px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-head b.record-income {
    color: #18a058;
}

.record-head b.record-expense {
    color: #ff4551;
}

.record-meta {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #edf0f6;
}

.record-meta span,
.record-meta time {
    overflow: hidden;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-meta time {
    margin-left: 12px;
    color: #687083;
    text-align: right;
}
</style>
